/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Flex, Grid, Heading, jsx, Text } from 'theme-ui'
import CallToAction from '~/components/Content/Section/CallToAction'

const TeamListSection = ({
  title,
  description,
  media,
  footer,
  cta,
  isTrade,
}) => {
  return (
    <Box
      bg="backgroundMedium"
      pt={[7, null, 9, 13]}
      pb={[8, null, 10]}
      sx={{ overflow: 'hidden' }}
    >
      <Container sx={{ position: 'relative' }}>
        <Box mb={[6, 7, 9]} sx={{ textAlign: 'center' }}>
          <Heading as="h2" variant="title2">
            {title}
          </Heading>
          {description && (
            <Box
              mt={2}
              variant="text.body1"
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
              sx={{ p: { m: 0 } }}
            />
          )}
        </Box>
        <Grid
          mb={[7, null, 9]}
          columns={[1, 2, null, 3]}
          sx={{
            position: 'relative',
            rowGap: [5, null, 6],
            '&:before': {
              backgroundImage: `url('/images/backgrounds/team-blob-right.svg')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
              top: ['52px', '-132px', '-173px', '-122px'],
              content: '""',
              display: 'block',
              right: ['-850px', '-742px', '-631px', '-438px'],
              position: 'absolute',
              height: '1144px',
              width: '961px',
            },
            '&:after': {
              backgroundImage: `url('/images/backgrounds/team-blob-left.svg')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
              content: '""',
              display: 'block',
              height: '1167px',
              left: ['-830px', '-791px', '-704px', '-694px'],
              position: 'absolute',
              bottom: ['67px', '-81px', '-106px', '-181px'],
              width: '1024px',
            },
          }}
        >
          {media.map(
            (
              { title, description, media_square, subtitle, cta, footer },
              index
            ) => {
              return (
                <Box
                  key={`card-${index}`}
                  pt={[5, 6]}
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                  }}
                >
                  <Flex
                    pb={4}
                    px={[3, null, 4]}
                    bg="white"
                    sx={{
                      borderRadius: '8px',
                      flexDirection: 'column',
                      height: '100%',
                    }}
                  >
                    <Box
                      mb={[2, null, 3]}
                      ml={[-1]}
                      mt={[-5, -6]}
                      sx={{
                        borderRadius: '50%',
                        overflow: 'hidden',
                        width: ['168px', '208px', '223px'],
                        transform: 'translateZ(0)',
                      }}
                    >
                      <GatsbyImage
                        image={media_square.gatsbyImageData}
                        alt={media_square.description}
                      />
                    </Box>

                    <Heading as="h3" mb={[null, '4px']} variant="title3">
                      {title}
                    </Heading>
                    {subtitle && (
                      <Text as="p" mb={2} variant="subtitle2">
                        {subtitle}
                      </Text>
                    )}
                    {description && (
                      <Box
                        mb={2}
                        variant="text.body3"
                        dangerouslySetInnerHTML={{
                          __html: description.childMarkdownRemark.html,
                        }}
                        sx={{
                          flexGrow: '1',
                          p: {
                            '&:first-of-type': {
                              mt: 0,
                            },
                            '&:last-of-type': {
                              mb: 0,
                            },
                          },
                        }}
                      />
                    )}
                    {footer && isTrade && (
                      <Box
                        mb={2}
                        variant="text.body3"
                        dangerouslySetInnerHTML={{
                          __html: footer.childMarkdownRemark.html,
                        }}
                        sx={{
                          p: {
                            '&:first-of-type': {
                              mt: 0,
                            },
                            '&:last-of-type': {
                              mb: 0,
                            },
                          },
                        }}
                      />
                    )}
                    {cta && (
                      <Text as="p" variant="body3">
                        <strong mb={'4px'}>Favorite Maker wine:</strong>
                        <CallToAction content={cta} type="text" />
                      </Text>
                    )}
                  </Flex>
                </Box>
              )
            }
          )}
        </Grid>
        {footer && (
          <Box
            sx={{
              position: 'relative',
              textAlign: 'center',
              zIndex: 1,
              a: {
                display: 'inline-block',
                marginBottom: -3,
                minHeight: '50px',
              },
            }}
          >
            <Box
              variant="text.title3"
              dangerouslySetInnerHTML={{
                __html: footer.childMarkdownRemark.html,
              }}
              sx={{ mb: [1, 2], p: { m: 0 } }}
            />
            {cta}
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default TeamListSection
